/**
 * 置く場所の選択を動画の上で選ぶときの切り抜き（純関数。Web の PlaceOnVideo と iPad アプリの PlaceOnVideo が同じものを使う。Issue #467 / #630）。
 */
import { placeKey } from './inputView';
import { zoneKeyOfPlaceKey } from './stage';

const finite = (r) => [r?.x, r?.y, r?.w, r?.h].every(Number.isFinite);
const ROW_ZONES = /^(monster|magic_trap|field):/;

/** 切り抜く矩形（動画のピクセル）: 置けるゾーンのある行を縦に含み、横は動画の幅いっぱい。材料が無ければ null */
export function placeCrop(options, zones, videoSize, pad = 16) {
  if (!videoSize || !zones) return null;
  const rects = options.map((p) => zones[zoneKeyOfPlaceKey(placeKey(p))]).filter(finite);
  if (!rects.length) return null;
  const y0 = Math.max(0, Math.min(...rects.map((r) => r.y)) - pad);
  const y1 = Math.min(videoSize.h, Math.max(...rects.map((r) => r.y + r.h)) + pad);
  return y1 > y0 ? { x: 0, y: y0, w: videoSize.w, h: y1 - y0 } : null;
}

/** 切り抜きに入るゾーン（モンスター・魔法罠・フィールドの行）: [[key, rect]] */
export function zonesInCrop(zones, crop) {
  if (!zones || !crop) return [];
  return Object.entries(zones).filter(([k, r]) => ROW_ZONES.test(k) && finite(r) && r.y + r.h > crop.y && r.y < crop.y + crop.h && r.x + r.w / 2 > 0 && r.x + r.w / 2 < crop.w);
}
